import React from 'react';

import {
  Accordian,
  Question,
  Answer,
  Group,
  Email,
  Call,
  CallSummit,
  EmailSummit,
  SupportCall,
  SupportEmail
} from './common';

export default function CommonFAQ() {
  return (
    <React.Fragment>
      <Accordian title="Why book Lukla flights with HoneyGuide?">
        <Group>
          <Question question="Specialized in Everest" />
          <Answer>
            We provide all the services and information required for the Everest trek via our website and mobile app. Apart from flight booking, we provide other services like hotel bookings, guide/porter booking, helicopter tours, and treks.
          </Answer>
        </Group>
        <Group>
          <Question question="Prompt Chat Support" />
          <Answer>
            If you need to reschedule your flights, cancel your reservation, or need information, we will be available 24 hours to help you. You can call or WhatsApp us at  <SupportCall />.
          </Answer>
        </Group>
        <Group>
          <Question question="Easy Rescheduling" />
          <Answer>
            You can call or WhatsApp us at <SupportCall />>, and we can reschedule your flights at no extra cost, depending upon flight availability.
          </Answer>
        </Group>
        <Group>
          <Question question="High priority in case of delays and rescheduling" />
          <Answer>
            In case of flight delays, we prioritize rescheduling the flights for the next possible flight or provide an alternative option by arranging a helicopter.
          </Answer>
        </Group>
        <Group>
          <Question question="Price Match Guarantee" />
          <Answer>
            When it comes to flight booking, our strategy is pretty straightforward: Match the price, Beat the Service. :)
          </Answer>
        </Group>
        <Group>
          <Question question="Helicopter Services" />
          <Answer>
            In case of flight cancellation, we can arrange helicopter service to Lukla.
          </Answer>
        </Group>
        <Group>
          <Question question="Multiple Payment Options" />
          <Answer>
            If you cannot book your flight due to payment failure, you can write to us at <SupportEmail /> or call / WhatsApp us at <SupportCall />.
            We will help you book your flight tickets and arrange an alternative medium of payment (either wire transfer or cash payment before 72 hours).
          </Answer>
        </Group>
      </Accordian>

      <Accordian title="About Lukla Flight">
        <Group>
          <Question question="Will there be an airport pickup/drop service on the day of my flight from/to Lukla?" />
          <Answer>
            No, there will be no airport pickup/drop service. The flight ticket which you issued includes only the flight service. But if needed, we can arrange it at an additional cost.
          </Answer>
        </Group>

        <Group>
          <Question question="How long is the flight to Lukla?" />
          <Answer>
            25 minutes. Lukla is 140 kilometers from Kathmandu as the crow flies. Make sure to book the earliest flight you can get. As the day progresses, the weather in the mountains gets unstable which increases the chance of flight cancellations. This will mainly be an issue during the October peak season.
          </Answer>
        </Group>

        <Group>
          <Question question="How do I get a free mountain flight when I book a flight to Lukla?" />
          <Answer>
            Simply sit on the mountainside when you board. :) Since there are no seat numbers in the flight to Lukla, you can sit anywhere. This means you need the first person off the bus which takes you to the plane. And you will have to make sure to sit on the left side of the plane when going to Lukla from Kathmandu to see the beautiful mountains. We will leave it to you to guess which side you need to sit on when flying from Lukla to Kathmandu.
          </Answer>
        </Group>

        <Group>
          <Question question="What is the baggage allowance for a flight to Lukla?" />
          <Answer>
            Check-in Baggage: 10 kilograms. Or for the metrically challenged citizens, 22 lbs. 2 pieces tops. Hand Carry: 5 kilograms. 11 lbs. Excess baggage is charged at the rate of USD 1 per kg.
          </Answer>
        </Group>

        <Group>
          <Question question="Do I need to confirm my flight booking?" />
          <Answer>
            No. Once your flight is booked, you do not need to reconfirm it. As soon as the booking process is complete, we will send you an email with an e-ticket and necessary details of your confirmed booking. You are requested to check your spam folder as well. If you do not receive tickets within 30 minutes, please email us at <Email /> or call / whatsapp us at <a href='https://wa.link/f8rul8'>+977 981-0102745</a>.
          </Answer>
        </Group>
        <Group>
          <Question question="Do I need to print my ticket?" />
          <Answer>
            No. You can simply show your e-ticket at the Airport Counter via any devices like phone or tablet. However, please make sure that you have downloaded the tickets and there’s no issue with device battery.
          </Answer>
        </Group>
        <Group>
          <Question question="How early should I get to the Airport to catch my Lukla flight?" />
          <Answer>
            It is advised to reach the Airport one hour before the flight time.
          </Answer>
        </Group>
      </Accordian>

      <Accordian title="Ramechhap to Lukla Flights">
        <Group>
          <Question question="What will be the price of the flights to Lukla from Ramechhap? What does it include?" />
          <Answer>
            The price of the flight from Kathmandu to Ramechap will be USD 149 and will include
          </Answer>
        </Group>

        <Group>
          <Question question="What kind of vehicle will be arranged?" />
          <Answer>
            The vehicle will be either a car, jeep, or a hiace/microvan depending on the number of people traveling that day.
          </Answer>
        </Group>

        <Group>
          <Question question="Where will the vehicle pick me up?" />
          <Answer>
            The vehicle departure location is in the most central point in Thamel (which should be more than 10 minutes walk from any hotels in and around Thamel). Alternatively, you can ask your hotel to drop you off at the pickup location.
          </Answer>
        </Group>

        <Group>
          <Question question="Will the vehicle pick me up from my hotel?" />
          <Answer>
            No, the vehicle will depart from the most central point of Thamel. But don't worry, it will not be more than 10 minutes walk from any hotels in and around Thamel. Alternatively, you can ask your hotel to drop you off at the pickup location.
          </Answer>
        </Group>

        <Group>
          <Question question="Will I get vehicle details with the flight tickets?" />
          <Answer>
            You will receive transportation confirmation in the same email with the flight tickets. However, the details like driver’s contact and vehicle number will be sent to you a day before your flight. The driver will have your details, and you can simply show them your flight tickets.
          </Answer>
        </Group>

      </Accordian>

      <Accordian title="Flight Disruptions">
        <Group>
          <Question question="What are the chances of flight disruptions?" />
          <Answer>
            Lukla weather is a significant factor impacting the flight. While early mornings are clear in the mountains, a tailwind gradually builds up through the afternoon. So if you have booked your ticket for the first flight, there is a low chance of flight disruption. But it depends upon how the weather acts during that time.
          </Answer>
        </Group>

        <Group>
          <Question question="What happens if the weather gets bad and the flight gets delayed?" />
          <Answer>
            If the weather gets bad and the flight gets delayed, the airline will wait for a certain time for the weather to get clear. If the weather doesn’t clear, they will cancel the flights for that day. In that case, you can call / WhatsApp us at <a href='https://wa.link/f8rul8'>+977 981-0102745</a>. (a)You will have the option to shift your booking for the next day or get fully refunded. (b)The flights that got canceled get higher priority the next day. If needed, we can arrange a helicopter starting from USD 2200- USD 2500. If not helicopter, then we can take you to Phaplu or Thaksindu on the same day by Jeep, and the prices ranges from NPR
          </Answer>
        </Group>

        <Group>
          <Question question="What happens when flight gets canceled?" />
          <Answer>
            If your flight gets canceled, you can call / whatsapp us at <a href='https://wa.link/f8rul8'>+977 981-0102745</a>. You have options to either shift your booking for the next day or get a full refund. (a) Generally, the flights that got canceled get higher priority the next day. (b) If you want to request a refund, you can email us at <Email /> or call / whatsapp us at <a href='https://wa.link/f8rul8'>+977 981-0102745</a>.
          </Answer>
        </Group>

      </Accordian>

      <Accordian title="Changes in Reservations">
        <Group>
          <Question question="How Do I Change a Flight Reservation?" />
          <Answer>
            If you wish to reschedule the flight date or times, you can call / whatsapp us at <a href='https://wa.link/f8rul8'>+977 981-0102745</a> or  email us at <Email />. We will make the changes by checking the availability at no additional cost.
          </Answer>
        </Group>

        <Group>
          <Question question="Is there any fee/charge if I want to change my Flight Reservation?" />
          <Answer>
            No. There is no fee/charge for making changes to your flight reservation unless you wish to cancel your reservation.
          </Answer>
        </Group>

        <Group>
          <Question question="How Do I Make Changes to Booking Information in case of mistakes and name changes?" />
          <Answer>
            If you wish to make any changes to your reservation (e.g., name changes, or email address correction), you can call / whatsapp us at <a href='https://wa.link/f8rul8'>+977 981-0102745</a>, or  email us at <Email />. We will make those changes for you.
          </Answer>
        </Group>

        <Group>
          <Question question="Can I change my flight date if I finish my trek earlier?" />
          <Answer>
            Yes. If you finish your trek earlier, you can call / whatsapp us at <a href='https://wa.link/f8rul8'>+977 981-0102745</a> or  email us at <Email />. We will make the changes if there are seats available for the earlier flight at no extra expense.
          </Answer>
        </Group>

      </Accordian>

      <Accordian title="Payment, Cancellation, and Refund Policy">
        <Group>
          <Question question="How Do I Cancel a Flight Reservation?" />
          <Answer>
            If you wish to cancel your flight reservation, please email us at <Email />  or call / whatsapp us at  <a href='https://wa.link/f8rul8'>+977 981-0102745</a>. We will cancel your reservation and initiate the refund process. Generally, the refund process takes 15-20 days. If you don’t receive your funds back within that period, kindly write to us for further assistance.
          </Answer>
        </Group>

        <Group>
          <Question question="Is there any fee/ charge if I want to cancel my Flight Reservation?" />
          <Answer>
            Yes. You will be charged a certain fee as per the Airline's policy if you cancel a booking, and the remaining amount will be refunded. (Generally, the cancellation charge starts from 10%, but please confirm the charges while requesting the refund.)
          </Answer>
        </Group>
        <Group>
          <Question question="What happens if my flight gets canceled due to weather or any other unanticipated event?" />
          <Answer>
            If your flight gets canceled, you can call / whatsapp us at <a href='https://wa.link/f8rul8'>+977 981-0102745</a>. You have options to either shift your booking for the next day or get a full refund. (a) Generally, the flights that got canceled get higher priority the next day. Please request the Airlines staff if you need to shift bookings. (b) If you want to request a refund, you can email us at <Email />  or call / whatsapp us at <a href='https://wa.link/f8rul8'>+977 981-0102745</a>.
          </Answer>
        </Group>
        <Group>
          <Question question="What should I do if I miss my flight?" />
          <Answer>
            If you miss your flight, take your boarding pass, ticket, or reservation confirmation to the airline ticket counter to ask for assistance. If not, you can call / whatsapp us at <a href='https://wa.link/f8rul8'>+977 981-0102745</a> and we will try to arrange the flight for the next available flight. But it is entirely up to the Airlines for making decisions on matters like these. If you need to change your reservation, you can call / whatsapp us at <a href='https://wa.link/f8rul8'>+977 981-0102745</a> or email us at <Email />
          </Answer>
        </Group>
        <Group>
          <Question question="How can I request a refund in case of flight cancellation or if I don’t claim the flight?" />
          <Answer>
            If you want to request a refund, please email us at <Email /> or call / whatsapp us at <a href='https://wa.link/f8rul8'>+977 981-0102745</a>.Generally, the refund process takes 15-20 days. If you don’t receive your funds back within that period, kindly write to us for further assistance.
          </Answer>
        </Group>
        <Group>
          <Question question="How long does it take for funds to be refunded?" />
          <Answer>
            Generally, the refund process takes 15-20 days after you request refunds. If you don’t receive your funds back within that period, kindly write to us at <Email /> for further assistance.
          </Answer>
        </Group>
      </Accordian>

      <Accordian title="Other Services">
        <Group>
          <Question question="Can you guys also help with my trip planning?" />
          <Answer>
            Yes, we also help in trip planning for Everest. For this you can email us at <a href='mailto:busybee@honeyguideapps.com'>busybee@honeyguideapps.com</a>  or call / whatsapp us at <a href='https://wa.link/rxum7t'>+977-9803759639</a>. We also run treks in the Everest Region. If you are interested then you can visit: <a href='https://honeyguideapps.com/treks'>https://honeyguideapps.com/treks</a>
          </Answer>
        </Group>

        <Group>
          <Question question="Do I have options to book accommodations in the Everest Region? Do you have recommendations for good teahouses?" />
          <Answer>
            Yes. HoneyGuide has an inventory of accommodations listed including services they provide, price and reviews from trekkers. You can even book your accommodations in Everest online. To book or learn more: <a href='https://honeyguideapps.com/lodges'>https://honeyguideapps.com/lodges</a>
          </Answer>
        </Group>

        <Group>
          <Question question="I wish to get a guide/ porter guide/ porter guide for my trek. How can I book them?" />
          <Answer>
            Honeyguide helps you connect directly with guides. To request a guide or learn more: <a href='https://honeyguideapps.com/guides'>https://honeyguideapps.com/guides</a>
          </Answer>
        </Group>

      </Accordian>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/StaticSections/CommonFAQ.js